import GQFlag from '../GQFlag';
import GQButton  from '../GQButton/GQButton';
type ToggleButtonType = 'single' | 'multi';

export function Separator() {
    return <div className="gq-navbar-vertical-separator marginSides" />;
}

export function Flag(props: { countryId?: number }) {
    if (!props.countryId) {
        return (
            <div className="top-nav-country-flag">
                <div className="empty-flag" />
            </div>
        );
    }

    return (
        <div className="top-nav-country-flag">
            <GQFlag countryId={props.countryId} className="flag-icon-squared" />
        </div>
    );
}

export function CountryName(props: {countryName?: string}) {
        return (
            <div className="top-nav-country-name">
                {props.countryName ? props.countryName : 'Select country'}
            </div>
        );
}
export const renderTogglePickerButton = (
    toggleButtonType: ToggleButtonType
) => {
    return ({ isVisible }: { isVisible: boolean }) => {
        return toggleButtonType === 'single' ? (
            <GQButton
                icon="gqi-dropdown"
                noBorder={true}
                noPadding={true}
                style={{
                    fontSize: '20px',
                    color: 'rgba(255,255,255,0.6)',
                    verticalAlign: 'middle',
                }}
            />
        ) : (
            <GQButton
                icon={isVisible ? 'gqi-check-circle' : 'gqi-plus-circle'}
                noBorder={true}
                noPadding={true}
                style={{
                    fontSize: '21px',
                    color: 'rgba(255,255,255,0.6)',
                    verticalAlign: 'middle',
                    backgroundColor: 'rgba(255, 255, 254, 0.2)',
                    borderRadius: '50%',
                    width: '19px',
                    height: '19px',
                    marginTop: '1px',
                }}
            />
        );
    };
};
